export const CONTENT_STATUS_CONFIG = {
    PUBLISHED: "published",
    UNPUBLISHED: "unpublished",
    ACTIVE: "active",
    INACTIVE: "inactive",
    SCHEDULED: "scheduled",
}

// Multiligual Languages
export const languagesForContent = [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Hindi",
      value: "Hindi",
    },
    {
      label: "Marathi",
      value: "Marathi",
    },
    {
      label: "Gujarati",
      value: "Gujarati",
    },
    {
      label: "Tamil",
      value: "Tamil",
    },
    {
      label: "Kannada",
      value: "Kannada",
    },
  ];
  
  export const DRAWER_MODE = {
    create: "create",
    edit: "edit",
    view: "view",
  };
  
  export const CONTENT_ACTION_CONFIG = {
    PUBLISH: "publish",
    UNPUBLISH: "unpublish",
    ACTIVATE: "active",
    DEACTIVATE: "deactivate",
  }
  
  export const CONTENT_TYPES_CONFIG = {
    SHLOKA: "shloka",
    QUOTE: "quote",
    NEWS: "news",
    INFORMATION: "information",
    PODCAST: "podcast",
    AUDIO: "bhaktisangeet",
    E_BOOK: "ebook",
    MAGAZINES: "magazine",
    FAQ: "faq",
    TOPIC: "topic",
    CHAPTER: "chapter",
    MEDIA: "media",
    COMIC: "comic",
    MCQ: {
      CHAPTER: "chapter mcq",
      TOPIC: "topic mcq",
    },
    TESTIMONIAL: "testimonial",
  }

  export const languagesForHinduCalendar = {
    english: "en",
    hindi: "hi",
    marathi: "ma",
    gujarati: "en",
    tamil: "tm",
    kannada: "kn",
  }